import { RadioGroup } from '@material-ui/core';
import styled from 'styled-components';

export default styled(RadioGroup)`
  flex-direction: column;
`;
